import React from 'react';
import { Grid, Box, Skeleton, VStack, HStack, useBreakpointValue } from '@chakra-ui/react';

interface AddToListModalSkeletonProps {
  count?: number;
}

export const AddToListModalSkeleton: React.FC<AddToListModalSkeletonProps> = ({ 
  count = 4 
}) => {
  const columns = useBreakpointValue({ base: 1, sm: 1, md: 2 });

  return (
    <VStack spacing={4} align="stretch">
      {/* Header with "Select a list" and "Create New" button */}
      <HStack justify="space-between">
        <Skeleton 
          height="24px" 
          width="120px"
          startColor="gray.200"
          endColor="gray.300"
        />
        <Skeleton
          height="32px"
          width="100px"
          borderRadius="var(--r-chip)"
          startColor="purple.200"
          endColor="purple.300"
        />
      </HStack>

      {/* Grid of list cards */}
      <Grid templateColumns={`repeat(${columns}, 1fr)`} gap={4}>
        {Array.from({ length: count }, (_, index) => (
          <Box
            key={index}
            p={4}
            borderWidth="2px"
            borderColor="var(--card-divider)"
            borderRadius="var(--r-card-compact)"
            bg="var(--card-bg)"
          >
            <VStack align="start" spacing={2}>
              <HStack justify="space-between" w="100%">
                <Skeleton 
                  height="16px" 
                  width="80%"
                  startColor="gray.200"
                  endColor="gray.300"
                />
                <Skeleton 
                  height="20px" 
                  width="60px"
                  borderRadius="full"
                  startColor="green.200"
                  endColor="green.300"
                />
              </HStack>

              <HStack spacing={2}>
                <Skeleton 
                  height="20px" 
                  width="60px"
                  borderRadius="full"
                  startColor="gray.200"
                  endColor="gray.300"
                />
                <Skeleton 
                  height="20px" 
                  width="50px"
                  borderRadius="full"
                  startColor="purple.200"
                  endColor="purple.300"
                />
              </HStack>
            </VStack>
          </Box>
        ))}
      </Grid>
    </VStack>
  );
};